
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientPackageData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientPackage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client_product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_event_booking_support"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_hq_support"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_invoiceable"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unique_sportradar_contract_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content_activation_ticket_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sf_contract_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client_package_type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"minimum_spend_commitment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"event_booking_type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"booking_type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"content_package_types"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"event_content_variants"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"is_hq"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_ll"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_test"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sla_minimum_threshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"start_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"end_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cdn_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_additional_cdn_bucket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_cdn_bucket_size_gb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_disabled"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangelogData"},"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientPackageDetailedDataGlobeIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientPackageContent"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"territory_selection_type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicData"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicData"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"country_subdivisions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySubdivisionIsoCodeBasicData"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1197}};
    doc.loc.source = {"body":"#import \"../interface.graphql\"\n#import \"../clientPackageGeoRestrictionUsage/fragment.graphql\"\n#import \"../countrySubdivision/fragment.graphql\"\n\nfragment ClientPackageData on ClientPackage {\n    id\n    client_product {\n        id\n        product {\n            id\n            has_event_booking_support\n            has_hq_support\n            is_invoiceable\n        }\n    }\n    name\n    description\n    unique_sportradar_contract_number\n    content_activation_ticket_number\n    sf_contract_number\n    client_package_type {\n        id\n    }\n    minimum_spend_commitment\n    event_booking_type {\n        id\n    }\n    booking_type {\n        id\n    }\n    content_package_types {\n        id\n    }\n    event_content_variants {\n        id\n    }\n    is_hq\n    is_ll\n    is_test\n    sla_minimum_threshold\n    start_date\n    end_date\n    cdn_price\n    has_additional_cdn_bucket\n    additional_cdn_bucket_size_gb\n    is_disabled\n    ...ChangelogData\n}\n\nfragment ClientPackageDetailedDataGlobeIcon on ClientPackageContent {\n    id\n    territory_selection_type {\n        ...BasicData\n    }\n    countries {\n        ...BasicData\n    }\n    country_subdivisions {\n        ...CountrySubdivisionIsoCodeBasicData\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../interface.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../clientPackageGeoRestrictionUsage/fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../countrySubdivision/fragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ClientPackageData"] = oneQuery(doc, "ClientPackageData");
        
        module.exports["ClientPackageDetailedDataGlobeIcon"] = oneQuery(doc, "ClientPackageDetailedDataGlobeIcon");
        
